import { defineStore } from 'pinia'

import { STORAGE_KEYS } from '@/constants/storage'
import type { StudioSummary } from '@/types'

interface StudioState {
  studios: StudioSummary[]
  currentStudioId: string | null
}

export const useStudioStore = defineStore('studio', {
  state: (): StudioState => ({
    studios: [],
    currentStudioId:
      localStorage.getItem(STORAGE_KEYS.studioId) || localStorage.getItem('active_studio_id'),
  }),
  getters: {
    currentStudio: (state) =>
      state.studios.find((studio) => studio.id.toString() === state.currentStudioId) ?? null,
    hasMultipleStudios: (state) => state.studios.length > 1,
  },
  actions: {
    initializeFromProfile(studios: StudioSummary[]) {
      this.studios = studios
      if (!studios.length) {
        this.currentStudioId = null
        localStorage.removeItem(STORAGE_KEYS.studioId)
        return
      }

      const storedId = localStorage.getItem(STORAGE_KEYS.studioId)
      const isStoredValid = storedId && studios.some((studio) => studio.id.toString() === storedId)

      if (isStoredValid) {
        this.currentStudioId = storedId
        return
      }

      const firstStudio = studios[0]
      if (!firstStudio) return
      this.setCurrentStudio(firstStudio.id.toString())
    },
    setCurrentStudio(studioId: string) {
      this.currentStudioId = studioId
      localStorage.setItem(STORAGE_KEYS.studioId, studioId)
      localStorage.setItem('active_studio_id', studioId)
    },
    clear() {
      this.studios = []
      this.currentStudioId = null
      localStorage.removeItem(STORAGE_KEYS.studioId)
      localStorage.removeItem('active_studio_id')
    },
  },
})
